// generated by genversion
export var version = '4.2.5';
//# sourceMappingURL=version.js.map